import React,{ useEffect, useState, useRef, useContext } from 'react'
import Layout from '../layout/default';
import {Icon, Block, BlockHead, BlockHeadBetween, BlockHeadContent, DatePicker, TimePicker } from '../components';
import { monthList} from '../utilities';
import {Popover,OverlayTrigger, Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import FullCalendar, { CalendarApi, CalendarDataManager, CalendarRoot } from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import listPlugin from '@fullcalendar/list'
import Spinner from 'react-bootstrap/Spinner';
import { Navigate } from "react-router-dom";
import { Image, Media } from '../components';
import ClientListSelect2 from '../components/ClientList/ClientListSelect2';
import toTimeOnly from '../utilities/toTimeOnly';
import JobsheetDetail from '../components/Jobsheet/JobsheetDetail';
import CheckStaffAvailablity from '../components/Jobsheet/CheckStaffAvailablity';
import { useApiClient } from '../ApiService/useApiClient';
import { AppContext } from '../context/AppContext';

const baseURL = "HMCareTask/summarytasklist/";
const baseURL2 = "HMCareStaff/stafflist/";    

let calendarRef = React.createRef();

function renderEventContent(eventInfo) {
    
  const timeText = eventInfo.timeText, 
        title = eventInfo.event._def.title,         
        description = eventInfo.event._def.extendedProps.description, 
        serviceType = eventInfo.event._def.extendedProps.serviceType,
        serviceTypeName = eventInfo.event._def.extendedProps.serviceTypeName,
        fundingType = eventInfo.event._def.extendedProps.fundingType, 
        carerAssignments = eventInfo.event._def.extendedProps.carerAssignments, 
        start = eventInfo.event.startStr,           
        end = eventInfo.event.endStr,    
        view = eventInfo.view.type,
        
        popover = (
          <Popover className='event-popover'>
            <Popover.Header as="h3">{title}</Popover.Header>
            <Popover.Body>
                <Icon variant="primary" size="4" name="clock"></Icon>
                {toTimeOnly(start)} - {toTimeOnly(end)}<br></br>                
                Service : {serviceTypeName} <br></br>
                Funding : {fundingType}<br></br>
                Assigned Carer(s) : {carerAssignments} <br></br>                
                </Popover.Body>
          </Popover>
        )
       

  return (
    <>
      

      {/* {timeText && (view === 'dayGridMonth') && <div className="fc-daygrid-event-dot"></div>}
      {timeText && <div className="fc-event-time">{timeText}</div>} */}
      {/* {start && end && (view === 'dayGridMonth') && <div className="fc-event-time"><Icon name="clock"></Icon> {toTimeOnly(start)} - {toTimeOnly(end)}</div>}  */}
      {start && end && <div className="fc-event-time"><Icon name="clock"></Icon> {toTimeOnly(start)} - {toTimeOnly(end)}</div>} 
     
      <div className="fc-event-title">{title}</div>
      <OverlayTrigger trigger={['hover','focus']} placement="top" overlay={popover}>
        <div className='fc-event-popover' style={{position:'absolute', inset: '0'}}></div>
      </OverlayTrigger>
      
    </>
  )
}


function JobScheduleStaff() {

    const api = useApiClient()
    const { user, SiteConfig } = useContext(AppContext);

// eslint-disable-next-line 
const modalForm = useRef(null);
const selectEvent = []
const formDefault = {
    opened: false
}

    const [events, setEvents] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(selectEvent);
    const [previewModal, setPreviewModal] = useState(false);
    const [ClientsModal, setClientsModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [formModal, setFormModal] = useState(formDefault);

    const[clients, setClients] = useState(null);  
    
    const[error, setError] = useState(null); 
    const[CurrentClient, setCurrentClient ] = useState(localStorage.getItem("LastSeletedStaff"));
    //const[CurrentStaff, setCurrentStaff ] = useState(JSON.parse(localStorage.getItem("LastSeletedStaff")))  
    const[serviceList, setServiceList] = useState(null);
    const[stafflist, setstafflist] = useState(null);  

    const [selectedAssignedAgents, setselectedAssignedAgents] = useState(null);
    const [selectedAssignedAgentsNames, setselectedAssignedAgentsNames] = useState(null);

const [CurrentDatesetStart, setCurrentDatesetStart] = useState(new Date().toISOString())
const [CurrentDatesetEnd, setCurrentDatesetEnd] = useState(new Date().toISOString())

const[isLoading, setIsLoading] = useState(true)

const [clientMode, setClientMode] = useState(true);
const [staffMode, setStaffMode] = useState(false);

const [selAvailCarers, setselAvailCarers] = useState([]);
const [selAvailCarersNames, setselAvailCarersNames] = useState([]);
const [AvailableCarersModal, setAvailableCarersModal] = useState(false);

const ApiGetData = async (URL,setdataFunc, setErrorFunc) => {
    try{
    const response = await api.get(URL);
        setdataFunc(response.data);        
    } catch(error) {
        setErrorFunc(error);      
    }
  };

    const handleAgentSelectChange = (selectedOption) => {


        //console.log(selectedOption.target.options);

        var options = selectedOption.target.options;
        var value = [];
        var sNames = "";
        for (var i = 0, l = options.length; i < l; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
            if(sNames!="") sNames = sNames + ','
            sNames = sNames + options[i].label;
          }
        }    
      setselectedAssignedAgents(value);
      setselectedAssignedAgentsNames(sNames);
      //console.log(`Option selected:`, value);
      //console.log(`Option selected:`, sNames);
    };


    

    // const headers = {
    //          'Authorization': 'Bearer '+ localStorage.getItem(SiteConfig.API_AUTH_TOKEN)      
    //        };

    useEffect(()=>{

               
        //!CurrentClient && ApiGetData(baseURL2,setClients, setError);
        ApiGetData(baseURL2,setClients, setError);
            


        // if(SiteConfig.CURRENT_USER_ROLE !="admin" && clients ){

        //     const currUserDataObj = clients.find(obj => {
        //         return obj.agentId == SiteConfig.CURRENT_USER_ID ;
        //       });
    
        //       console.log(currUserDataObj);
        //       return null
    
        //       clientSelect(currUserDataObj);
        // }

     
        //if(clients && !CurrentClient) openClientModal()
    
      // !error && clients && ApiGetData(baseURL,setEvents, setError);                   
       if (CurrentClient && CurrentClient.agentId) {
    ApiGetData(baseURL, setEvents, setError);
  }

      


//console.log(clients);
//return null


        }, []); 
    
    
    function closePreviewModal(){
      setPreviewModal(false);
    }

    function closeClientsModal(){
        setClientsModal(false);
    }

    function openClientModal(){
       
        !clients &&
        ApiGetData(baseURL2,setClients, setError);     

        setClientsModal(true);
        //setDeleteModal(true);        
      }

    //   function clientSelect(client){
        
    //     setCurrentClient(client);
    //     //localStorage.setItem("LastSeletedClient",JSON.stringify(client));  
    //     localStorage.setItem("LastSeletedStaff",JSON.stringify(client));  
      
    //     const DataUrl = baseURL + CurrentDatesetStart +'/'+ CurrentDatesetEnd +'/ /'+ client.agentId
        
    //     ApiGetData(DataUrl,setEvents, setError);

    //     setClientsModal(false);

    //   }

function clientSelect(client) {
  setCurrentClient(client);
  localStorage.setItem("LastSeletedStaff", JSON.stringify(client));

  if (client && client.agentId) {
    const DataUrl =
      baseURL +
      CurrentDatesetStart +
      "/" +
      CurrentDatesetEnd +
      "/ /" +
      client.agentId;
    ApiGetData(DataUrl, setEvents, setError);
  }
  setClientsModal(false);
}



function AvailableCarersSelect(client){
        
        //alert(client.agentId + '==' + client.name);
        
        setselAvailCarers([...selAvailCarers,client.agentId])
        setselAvailCarersNames([...selAvailCarersNames,client.name])
        
        //alert(selAvailCarers.length);
        //console.log(selAvailCarersNames);

        setAvailableCarersModal(false);

      }


    function AssignAgentSelect(TaskID,client){

        const x = ""+client.id;

        let xx = formModal.carerAssignmentIds;
        let d = xx.push(x);

        const updateFormModal = {...formModal, 
            carerAssignmentIds : xx,           
        }
        setFormModal(updateFormModal);

        //console.log(formModal);    
    }
    function deleteStaffClick(staff){

        //const x = ""+client.id;

        let xx = formModal.carerAssignmentIds.filter(p=> p !== staff);
        ///let d = xx.push(x);

        const updateFormModal = {...formModal, 
            carerAssignmentIds : xx,           
        }
        setFormModal(updateFormModal);

        //console.log(formModal);    
    }


    function openDeleteModal(){
      setPreviewModal(false);
      setDeleteModal(true);
    }

    function closeDeleteModal(){
      setDeleteModal(false);
      setSelectedEvent(selectEvent);
    }

    function openAddModal(){

        
        const updateFormModal = {...formModal, 
            opened:true,
            modalTitle: "Add Schedule",
            action: 'add',
            eventTitle: CurrentClient ? CurrentClient.name : '',
            eventStartTime: '',
            eventStartDate: '',
            eventEndTime: '',
            eventEndDate: '',
            eventDescription:'',
            eventCategory:'',
            fundingType : '',
            serviceType : '',
            carerAssignments : '',
            carerAssignmentIds : []
           
        }
      

        const baseURL3 = "HMCareData/servicelist/"; 
        !serviceList && ApiGetData(baseURL3,setServiceList, setError);
        
        const baseURL4 = "HMCareStaff/stafflistsummary/"; 
        !stafflist && ApiGetData(baseURL4,setstafflist, setError);
        
        setFormModal(updateFormModal);
    }

    function openEditModal(){
        setPreviewModal(false);
        const updateFormModal = {...formModal, 
            opened:true,
            modalTitle: "Edit Schedule",
            action: 'edit',
            eventTitle: selectedEvent.title,
            eventStartTime: selectedEvent.startTime,
            eventStartDate: selectedEvent.startDate,
            eventEndTime: selectedEvent.endTime,
            eventEndDate: selectedEvent.endDate,
            eventDescription:selectedEvent.description,
            eventCategory:selectedEvent.className,
            fundingType:selectedEvent.fundingType,
            serviceType:selectedEvent.serviceType,
            serviceTypeName:selectedEvent.serviceTypeName,
            carerAssignments:selectedEvent.carerAssignments,
            carerAssignmentIds:selectedEvent.carerAssignmentIds,
        }

        const baseURL3 = "HMCareData/servicelist/"; 
        !serviceList && ApiGetData(baseURL3,setServiceList, setError);
              
        const baseURL4 = "HMCareStaff/stafflistsummary/"; 
        !stafflist && ApiGetData(baseURL4,setstafflist, setError);
  
        setFormModal(updateFormModal);
        setselectedAssignedAgents(selectedEvent.carerAssignmentIds);
    }

    function closeFormModal(){
        const updateFormModal = {...formModal, opened:false}
        setFormModal(updateFormModal);
    }

    const globalFcStyle = `
        .fc-list-event-title {
          position:relative;
        }
    `
    
    function handleEventClick(eventInfo){
      let title = eventInfo.event._def.title;
      let description = eventInfo.event._def.extendedProps.description;
      let start = eventInfo.event._instance.range.start;
      let startDate = start.getFullYear() + '-' + String(start.getMonth() + 1).padStart(2, '0') + '-' + String(start.getDate()).padStart(2, '0');
      let startDateEng = String(start.getDate()).padStart(2, '0') + ' ' + monthList[start.getMonth()] + ' ' + start.getFullYear();
      let startTime = start.toUTCString().split(' '); startTime = startTime[startTime.length-2]; startTime = (startTime === '00:00:00') ? '' : startTime;
      let end = eventInfo.event._instance.range.end;
      let endDate = end.getFullYear() + '-' + String(end.getMonth() + 1).padStart(2, '0') + '-' + String(end.getDate()).padStart(2, '0');
      let endDateEng = String(end.getDate()).padStart(2, '0') + ' ' + monthList[end.getMonth()] + ' ' + end.getFullYear();
      let endTime = end.toUTCString().split(' '); endTime = endTime[endTime.length-2]; endTime = (endTime === '00:00:00') ? '' : endTime;
      let className = eventInfo.event._def.ui.classNames[0].slice(3);
      let eventId = eventInfo.event._def.publicId;
      
      let serviceType = eventInfo.event._def.extendedProps.serviceType;
      let fundingType = eventInfo.event._def.extendedProps.fundingType;
      let serviceTypeName = eventInfo.event._def.extendedProps.serviceTypeName;
      let carerAssignments = eventInfo.event._def.extendedProps.carerAssignments;
      let carerAssignmentIds = eventInfo.event._def.extendedProps.carerAssignmentIds;

       // alert(fundingType +''+serviceType)

        // console.log(eventId)
        // return null

      const currentEvent = {...selectedEvent, 
        id:eventId,
        title:title, 
        description:description, 
        className:className, 
        startTime: startTime,
        startDate: startDate,
        startDateEng: startDateEng,
        endTime: endTime,
        endDate: endDate,
        endDateEng: endDateEng,
        serviceType : serviceType,
        fundingType : fundingType,
        carerAssignments : carerAssignments,
        serviceTypeName : serviceTypeName,
        carerAssignmentIds : carerAssignmentIds,
      }
      setSelectedEvent(currentEvent);
      setPreviewModal(true)
    }

   
    function handleDeleteEvent(){

        const frmFormData = new FormData();
        const sURL = "HMCareTask/deletetask/" + selectedEvent.id;
       
        api.post(sURL,frmFormData)
        .then((Response)=>{
            //setClients(Response.data);
           // console.log(Response.data)

            const updatedEvents = events.filter((item) => item.id !== selectedEvent.id)
            setEvents(updatedEvents);
            setDeleteModal(false);
            setSelectedEvent(selectEvent)    

        }).catch(error => {
            setError(error);     
            //console.log({error})
        });


    }

    function handleFormSubmit(event){

        event.preventDefault();
        let newTitle = modalForm.current.querySelector('#eventTitle').value; 
        let neWStartDate = modalForm.current.querySelector('#eventStartDate').value; 
        let newStartTime = modalForm.current.querySelector('#eventStartTime').value; 
        let neWEndDate = modalForm.current.querySelector('#eventEndDate').value; 
        let newEndTime = modalForm.current.querySelector('#eventEndTime').value; 
        let newDescription = modalForm.current.querySelector('#eventDescription').value; 
        let neWclassName = "event-primary"; //modalForm.current.querySelector('#eventCategory').value; 
        let neWServiceType = modalForm.current.querySelector('#ServiceType').value; 
        let neWFundingType = modalForm.current.querySelector('#fundingType').value; 
        //let neWtt = modalForm.current.querySelector('#exampleFormControlInputText5').value; 
        //let neWcarerAssignments =  modalForm.current.querySelector('#carerAssignmentIds').value; 
        //let NewCarerAssignmentIds = selectedAssignedAgents; //"101,1011"; //modalForm.current.querySelector('#carerAssignmentIds').value; 
        let NewCarerAssignmentIds = formModal.carerAssignmentIds; 

        //console.log(selectedOption.target.options);

       


        //alert(selectedAssignedAgents);
        //console.log(selectedAssignedAgents);
        //console.log('neWEndDate ==' +neWEndDate);

       // let neWcarerAssignments = NewCarerAssignmentIds;
         
        //console.log(formModal.action);

        //return null

        const frmFormData = new FormData();
        frmFormData.append("customerid", CurrentClient.customerid) // newTitle)
        frmFormData.append("title", "")  
        frmFormData.append("TaskDate", neWStartDate)  
        frmFormData.append("end", neWEndDate + (newEndTime ? 'T' + newEndTime + 'Z' : ''))  
        frmFormData.append("start", neWStartDate + (newStartTime ? 'T' + newStartTime + 'Z' : ''))  
        frmFormData.append("service_id", (neWServiceType ? neWServiceType : '3694') )  
        frmFormData.append("funding", (neWFundingType ? neWFundingType : 'client'))  
        frmFormData.append("AdminNotes", newDescription)  
        frmFormData.append("carerAssignmentIds",NewCarerAssignmentIds)
              
        let sURL = "HMCareTask/task/add/";

        if(formModal.action=="edit"){
            frmFormData.append("TaskId",selectedEvent.id)
            sURL = "HMCareTask/task/update/";
        }

        //console.log(frmFormData);
        //return null

          api.post(sURL,frmFormData,)
          .then((Response)=>{
              //setClients(Response.data);
              //console.log(Response.data)
              let UpdatedDataObj = Response.data;    
              
              if(UpdatedDataObj!=null){
  
              let newEvent= {
                  id: UpdatedDataObj.id || 'added-event-id-' + Math.floor(Math.random()*9999999),
                  title: UpdatedDataObj.title,
                  start: UpdatedDataObj.start, 
                  end: UpdatedDataObj.end, 
                  className: UpdatedDataObj.className,
                  serviceType : UpdatedDataObj.serviceType,
                  fundingType : UpdatedDataObj.fundingType,
                  serviceTypeName : UpdatedDataObj.serviceTypeName,
                  carerAssignments: UpdatedDataObj.carerAssignments,
                  carerAssignmentIds: UpdatedDataObj.carerAssignmentIds,
              }
              setEvents([...events,newEvent]);
          }
  
          //setselAvailCarers([]);
          //setselAvailCarersNames([]);
  
          }).catch(error => {
              setError(error);     
              //console.log({error})
          });
    }

    function handleEditEvent(e){
        const updatedEvents = events.filter((item) => item.id !== selectedEvent.id)
        setEvents(updatedEvents);
        closeFormModal();
    }

    function handleAddEvent(e){        
        closeFormModal();
    }


    // function datesSetChange(dataInfo){
        
    //     setIsLoading(true)

    //     const DataUrl = baseURL + dataInfo.startStr+'/'+dataInfo.endStr + '/ /'+ CurrentClient.agentId
    //    // alert(DataUrl)

    //     ApiGetData(DataUrl,setEvents, setError)
    //     setIsLoading(false)

    //     setCurrentDatesetStart(dataInfo.startStr)       
    //     setCurrentDatesetEnd(dataInfo.endStr)       

    // }

    function datesSetChange(dataInfo) {
  setIsLoading(true);

  if (CurrentClient && CurrentClient.agentId) {
    const DataUrl =
      baseURL +
      dataInfo.startStr +
      "/" +
      dataInfo.endStr +
      "/ /" +
      CurrentClient.agentId;
    ApiGetData(DataUrl, setEvents, setError);
  } else {
    // Optionally, prompt user to select staff
    setEvents([]); // Or show a message
  }

  setIsLoading(false);
  setCurrentDatesetStart(dataInfo.startStr);
  setCurrentDatesetEnd(dataInfo.endStr);
}


function setMode(key){

    if(key=='custom-carer'){      
        setStaffMode(true)
        setClientMode(false)
    }
    else
        {
            setClientMode(true)    
            setStaffMode(false)
        }
}



    if (error) 
    {      
      if(error.message.indexOf("status code 401")){
        return <Navigate to="/auths/auth-login" />
      } else
      return "Error: ${error.message}";
    }

    if(!events || !clients || !CurrentClient || isLoading) (
        <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>
    );
    
    return (
        <>
        <Layout title="HMCarePlanner - Schedules" content="container">
       
        {/* {clientMode && <span>client</span>} == {staffMode&& <span>staff</span>} */}
            <BlockHead page>
                <BlockHeadBetween>
                    <BlockHeadContent>
                        {CurrentClient &&
                        <>
                        <div className="d-flex flex-column flex-md-row align-items-md-center">
                            <Media size="huge" shape="circle" variant='danger-soft'>
                                { 
                                    <Image src='/images/avatar/a.jpg' staticImage thumbnail alt="user"/>                              
                                }
                            </Media>
                            <div className="mt-3 mt-md-0 ms-md-3">
                                <h3 className="title mb-1">{CurrentClient.name}</h3>
                                <span className="small">{CurrentClient.emailId}</span> 
                                <ul className="nk-list-option pt-1">
                                    <li><Icon name="call-fill"></Icon><span className="small">{CurrentClient.mobileNo}</span></li>                                
                                </ul>
                            </div>
                        </div>
                        </>}

                        {!CurrentClient && SiteConfig.CURRENT_USER_ROLE =="admin" && 
                        <>                                              
                        <p><Button variant="primary" onClick={openClientModal}>Select Staff</Button></p>
                        </>}
                        </BlockHeadContent>
                    
                        {CurrentClient &&
                        <BlockHeadContent tools>
                            <ul className="d-flex gap g-3 justify-content-center">
                                <li>
                                    <Button variant="primary" action="add" onClick={openClientModal}>
                                        <Icon name="user"></Icon><span>Change Staff</span>
                                    </Button>
                                </li>
                                {/* <li>
                                    <Button variant="primary" action="add" onClick={openAddModal}>
                                        <Icon name="plus"></Icon><span>Add Schedule</span>
                                    </Button>
                                </li> */}
                            </ul>
                        </BlockHeadContent>}
                </BlockHeadBetween>
            </BlockHead>

            {CurrentClient &&
            <Block>
                <Card>
                    <Card.Body>
                        <style>{globalFcStyle}</style>
                        {isLoading && <p>Loading...</p>}
                        <FullCalendar                            
                            ref={calendarRef}
                            // customButtons={{ myCustomButton: {
                            //     text: 'custom!',
                            //     click: function() {
                            //       alert('clicked the custom button!');

                            //       let calendarApi = calendarRef.current.getApi();
                            //       calendarApi.next();
                            //     }
                            //   }}}
                            isLoading={isLoading} // use a function 
                            noEventsText={"No schedules"}                            
                            events= {events}
                            plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrapPlugin, listPlugin ]}
                            //initialView="dayGridMonth"
                            initialView="listWeek"
                            timeZone= 'UTC'
                            themeSystem= 'bootstrap'

                            datesSet={(dateInfo) => {
                                //console.log(dateInfo.start) //start of the range the calendar date
                                //console.log(dateInfo.end) //end of the range the calendar date
                                datesSetChange(dateInfo)
                            }}
                            
                            dateClick={(dateInfo)=>{
                                //console.log(dateInfo.date +'==='+dateInfo.date)    
                            }}

                            headerToolbar= {{
                                // left: 'title prev,next,myCustomButton',
                                left: 'title prev,next',
                                center: null,
                                right: 'today dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                            }}
                            height= {800}
                            contentHeight= {780}                            
                            aspectRatio= {3}
                            editable= {true}
                            droppable= {true}
                            views= {{
                                dayGridMonth: {
                                    dayMaxEventRows: 10,                                    
                                }
                            }}                            
                            eventContent={renderEventContent}
                            eventClick={handleEventClick}                                                   
                        />
                    </Card.Body>
                </Card>
            </Block>}
            
        </Layout>

        {/* Client select popup */}
        <ClientListSelect2 
            ClientsModal={ClientsModal}
            clientSelect={clientSelect}
            closeClientsModal={closeClientsModal}
            clients={clients}
        />
       

        <Modal show={previewModal} onHide={closePreviewModal} size="xl">
            <Modal.Header closeButton>
              <Modal.Title className="event-title" as="h4">{selectedEvent.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <JobsheetDetail taskid={selectedEvent.id} />              
              </div>
            </Modal.Body>
            <Modal.Footer>                
                <Button variant="light" onClick={closePreviewModal}>Cancel</Button>

                {SiteConfig.CURRENT_USER_ROLE == "admin" && 
                <>
                <Button variant="danger" onClick={openDeleteModal}>Delete</Button>
                <Button variant="primary" onClick={openEditModal}>Edit Schedule</Button>
                </>
                }
            </Modal.Footer>
        </Modal>

        <Modal show={deleteModal} onHide={closeDeleteModal}>
              <div className="modal-content">
                  <div className="modal-body p-5 text-center">
                      <div className="media media-rounded media-xxl media-middle mx-auto text-bg-danger mb-4"><em className="icon ni ni-cross"></em></div>
                      <h3>Are You Sure ?</h3>
                      <p className="small">This data will be removed permanently.</p>
                      <ul className="d-flex gap g-3 justify-content-center pt-1">
                          <li><Button variant="success" onClick={handleDeleteEvent}>Yes Delete it!</Button></li>
                          <li><Button variant="danger" className="btn-soft" onClick={closeDeleteModal}>Cancel</Button></li>
                      </ul>
                  </div>
                  <button type="button" className="btn-close position-absolute top-0 end-0 p-3" onClick={closeDeleteModal} aria-label="Close"></button>
              </div>
        </Modal>

        <Modal show={formModal.opened} onHide={closeFormModal} size="lg">
            <Form ref={modalForm} onSubmit={handleFormSubmit}>
                <Modal.Header closeButton>
                <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
                </Modal.Header>                
                <Modal.Body>

                    {!stafflist && <Spinner animation="border" variant="primary" />}             

                    { stafflist && <Row className="g-gs">
                        <Col xs="12">
                            <Form.Group>
                                <Form.Label htmlFor="eventTitle">Client</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="eventTitle" type="text" defaultValue={formModal.eventTitle} placeholder="Event Title" />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col sm="6">
                            <Form.Group>
                                <Form.Label htmlFor="eventStartDate" >Starts Date/Time</Form.Label>
                                <Row className="g-2">
                                    <Col xs="7">
                                        <div className="form-control-wrap">
                                            <DatePicker id="eventStartDate" value={formModal.eventStartDate} placeholder="yyyy-mm-dd"/>
                                        </div>
                                    </Col>
                                    <Col xs="5">
                                        <div className="form-control-wrap">
                                            <TimePicker id="eventStartTime" value={formModal.eventStartTime} placeholder="hh:mm"/>
                                        </div>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>
                        <Col sm="6">
                            <Form.Group>
                                <Form.Label htmlFor="eventEndDate">End Date/Time</Form.Label>
                                <Row className="g-2">
                                    <Col xs="7">
                                        <div className="form-control-wrap">
                                            <DatePicker id="eventEndDate" value={formModal.eventEndDate} placeholder="yyyy-mm-dd"/>
                                        </div>
                                    </Col>
                                    <Col xs="5">
                                        <div className="form-control-wrap">
                                            <TimePicker id="eventEndTime" value={formModal.eventEndTime} placeholder="hh:mm"/>
                                        </div>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>  
                        
                        <Col xs="12">
                            <Form.Group>
                            <Form.Label>Assigned Carers</Form.Label>
                            {/* <div className="form-control-wrap">
                                <Select onChange={handleAgentSelectChange} multiple id="carerAssignmentIds" defaultValue={formModal.carerAssignmentIds}  >                               
                                    {
                                    stafflist && stafflist.map((staff)=>
                                    <option value={staff.agentId}>{staff.name}</option>                                    
                                    )}                                
                                </Select>
                            </div>    */}

                            <div className="form-control-wrap">                                
                                {formModal.carerAssignmentIds && formModal.carerAssignmentIds.map((staff)=>
                                    <span key={staff}><Icon name="user-check-fill"></Icon>{staff}-{stafflist && stafflist.find((s)=>{ return s.agentId == staff; }).name} &nbsp;                                    
                                    <span style={{cursor:"pointer", size:"5px", }}  onClick={()=>{deleteStaffClick(staff)}}><u><Icon name="delete"></Icon></u></span>                                   
                                     <br></br></span>
                                    )}             

                            </div>  
                            <CheckStaffAvailablity TaskID={selectedEvent.id} SelectClick={AssignAgentSelect}/>   

                            </Form.Group>                       
                        </Col>                     
                    
                        <Col xs="6">
                            <Form.Group>
                            <Form.Label>Service Type</Form.Label>
                            <div className="form-control-wrap">
                                <Form.Select id="ServiceType" defaultValue={formModal.ServiceType}>
                                    {
                                    serviceList && serviceList.map((service)=>
                                    <option value={service.id}>{service.value}</option>                                    
                                    )}                                
                                </Form.Select>
                            </div>     
                            </Form.Group>                       
                        </Col>

                        

                           <Col xs="12">
                            <Form.Group>
                                <Form.Label htmlFor="eventDescription">Admin Notes</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="eventDescription" as="textarea" placeholder="Admin Notes" defaultValue={formModal.eventDescription} />
                                </div>
                            </Form.Group>
                        </Col>                 

                        <Col xs="6">                        
                        <Form.Label>Funding </Form.Label>
                            <div className="form-control-wrap">
                                <Form.Select id="fundingType" value={formModal.fundingType}>                                
                                    <option value="client">Client</option>
                                    <option value="council">Council</option>                                
                                </Form.Select>
                            </div>
                        </Col>
                    </Row>}
                </Modal.Body>
                <Modal.Footer>                    
                    <Button variant="danger" onClick={closeFormModal}>Discard</Button>
                    {formModal.action === 'add' && <Button variant="primary" type="submit" onClick={handleAddEvent}>Add Event</Button>}
                    {formModal.action === 'edit' && <Button variant="primary" type="submit" onClick={handleEditEvent}>Update Event</Button>}
                </Modal.Footer>
            </Form>
        </Modal>
        </>
    )
}

export default JobScheduleStaff